export class UpdateGarantieProduit
{
    garantieProduitId:number;
    code: String;
    label:String;
    produitId:number;
}